<template>
  <div>
    <div class="contain">
      <img class="imgs" src="../../../assets/c37/img01.png" ref="secondImage" />
      <img class="imgs" src="../../../assets/c37/img02.png" />
      <img class="imgs" src="../../../assets/c37/img03.png" />
      <img class="imgs" src="../../../assets/c37/img04.png" />
      <img class="imgs" src="../../../assets/c37/img05.png" />

      <!-- 유전자검사 한 번에 가족 건강까지 -->
      <!-- <img class="imgs" src="../../../assets/c37/img06.png" /> -->
      <img class="imgs" src="../../../assets/c37/img06-01.png" alt="일반질환 정밀검사 59종" />
      <img class="imgs pointer" src="../../../assets/c37/img06-02.png" alt="검사 질환 확인하기" @click="showModal1 = true" />
      <CustomModal
        :isOpen="showModal1"
        @close="showModal1 = false"
        title="일반질환 정밀검사 59종"
      >
        <div class="main-space">
          <p class="info-title">+ 대표암 5종 검사 무료 제공</p>
          <div class="box">
            <div class="box-section">
              <h3 class="section-title">공통항목 57종</h3>
              <div>
                <p class="box-text">
                  만성 B형간염, 비알코올성 지방간, 궤양성 대장염, 만성 폐쇄성 폐질환, 통풍, 제2형 당뇨병, 비만, 고중성지방혈증, 뇌졸중, 관상동맥질환, 심방세동, 심근경색증, 고혈압, 뇌동맥류, 골관절염, 골다공증, 크론병, 천식, 건선, 전신홍반루푸스, 아토피성 피부염, 류마티스 관절염, 녹내장, 황반변성, 치주염, 알레르기비염, 만발성 알츠하이머, 심부전, 빈혈, 만성 신부전증, 요로결석, 과민대장증후군, 위염, 담석증, 폐렴, 폐결핵, 그레이브스병(갑상선기능항진증), 갑상선기능저하증, 파킨슨병, 우울증, 양극성 장애(조울증), 공황장애, 편두통, 대상포진, 다발경화증, 요추 추간판탈출증(허리 디스크), 강직성 척추염, 켈로이드, 망막박리, 백내장, 난시, 고도근시, 치아우식증(충치), 기면증, 불면증, 수면 무호흡증, 하지불안증후군
                </p>
              </div>

              <h3 class="section-title">남성 2종</h3>
              <div>
                <p class="box-text">전립선비대증, 발기부전</p>
              </div>

              <h3 class="section-title">여성 2종</h3>
              <div>
                <p class="box-text">다낭성난소증후군, 요실금</p>
              </div>
            </div>
          </div>

          <div class="box blue">
            <div class="box-section">
              <h3 class="section-title">추가혜택  |  대표암 5종</h3>
              <div>
                <p class="box-text">
                  위암, 폐암, 대장암(직장암), 대장암(결장암), 간암
                </p>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      <img class="imgs" src="../../../assets/c37/img06-03.png" alt="남성암 + 여성암 각 5종" />
      <img class="imgs pointer" src="../../../assets/c37/img06-04.png" alt="검사 질환 확인하기" @click="showModal2 = true" />
      <CustomModal
        :isOpen="showModal2"
        @close="showModal2 = false"
        title="남성암 + 여성암 각 5종"
      >
        <div class="main-space">
          <p class="info-title">1+1 암 유전자 검사 패키지</p>
          <div class="box">
            <div class="box-section">
              <h3 class="section-title">남성암 5종</h3>
              <div>
                <p class="box-text">
                  위암, 폐암, 간암, 대장암(직장암), 전립선암
                </p>
              </div>

              <h3 class="section-title">여성암 5종</h3>
              <div>
                <p class="box-text">
                  위암, 유방암, 간암, 대장암(직장암), 갑상선암
                </p>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      <img class="imgs" src="../../../assets/c37/img06-05.png" alt="질병은 미리 대비할 수 있습니다. 가장 확실한 건강 선물, 유전자 검사" />


      <img class="imgs" src="../../../assets/c37/img07.png" />

      <div class="video-wrap" style="margin-top:142px">
        <iframe id="ytplayer" class="video-yt" type="text/html" src="https://www.youtube.com/embed/7CRGDk8ArOg?si=rVZSSz7kBHG8Y_iT&autoplay=1&mute=1&controls=0&loop=1&rel=0" title="YouTube video player" frameborder="0" allowfullscreen noresize></iframe>
      </div>

      <img class="imgs" src="../../../assets/c37/img08.png" />
      <img class="imgs" src="../../../assets/c37/img09.png" />
      <img class="imgs" src="../../../assets/c37/img10.png" />
      <img class="imgs" src="../../../assets/c37/img11.png" />

      <div class="video-wrap">
        <iframe id="ytplayer" class="video-yt" type="text/html" src="https://www.youtube.com/embed/Vu0Ns4gC3YA?si=Z5pLaxLD64cRwGj2&autoplay=1&mute=1&controls=0&loop=1&rel=0" title="YouTube video player" frameborder="0" allowfullscreen noresize></iframe>
      </div>

      <img class="imgs" src="../../../assets/c37/img12.png" />
      <img class="imgs" src="../../../assets/c37/img13.png" />

      <!-- <div style="height:90px; background-color:#3e3e3e">&nbsp;</div> -->

      <div :class="['full-bottom-float-cta', { scrolled: isScrolled}]">
        <slot-countdown-timer
          :start-date="new Date('2025-04-28T10:00:00')"
          :end-date="new Date('2025-05-31T23:59:59')"
        >
          <template v-slot:default="{days, hours, minutes, seconds, formattedDays, formattedHours, formattedMinutes, formattedSeconds, daysChars, hoursChars, minutesChars, secondsChars}">
            <div class="custom-timer-container">
              <div class="custom-timer-icon">
                <span>!</span>
              </div>
              <div class="custom-timer-title">
                <span class="point">혜택</span> 종료까지
              </div>
              <div class="custom-countdown">
                <div class="custom-time-block">

                  <div class="time-unit">
                    <div class="time-digits">
                      <!-- 일(Days) -->
                      <span v-for="(char, index) in daysChars" :key="`days-${index}`" class="digit">
                        {{ char }}
                      </span>
                      <span class="separator">:</span>
                      <!-- 시간(Hours) -->
                      <span v-for="(char, index) in hoursChars" :key="`hours-${index}`" class="digit">
                        {{ char }}
                      </span>
                      <span class="separator">:</span>
                      <!-- 분(Minutes) -->
                      <span v-for="(char, index) in minutesChars" :key="`minutes-${index}`" class="digit">
                        {{ char }}
                      </span>
                      <span class="separator">:</span>
                      <!-- 초(Seconds) -->
                      <span v-for="(char, index) in secondsChars" :key="`seconds-${index}`" class="digit">
                      {{ char }}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </slot-countdown-timer>
        <a @click="selfDeepLink" class="pointer">
            검사 신청하러 가기
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SlotCountdownTimer from "../../common/SlotCountdownTimer.vue";
import CustomModal from "../../common/CustomModal.vue";

export default {
    name: 'c37',
    components: {
      SlotCountdownTimer,
      CustomModal
    },
    data: function()
    {
        return {
            isScrolled: false,
            abx_tid: null,
            showModal1: false,
            showModal2: false,
            isInApp: false,
            ctaLink: 'https://official.soldoc.co.kr/api/v1/click/seCiMB9eaEylQn2jqLtJdg?abx_tracker_id=seCiMB9eaEylQn2jqLtJdg'
        }
    },
    methods: {
      deepLink: function()
      {
        window.location.href = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
      },
      selfDeepLink() {
        if(this.isInApp)
        {
          this.deepLink();
          return;
        }

        // 고정 링크가 존재한다면 리다이렉션 후킹
        if (this.ctaLink) {
          window.location.href = this.ctaLink;
          return;
        }

        if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone|iPad/i)) {
            window.location.href = 'https://event.soldoc.co.kr/';
            return;
        }

        if (!wcs_add) var wcs_add={};
            window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
            if (!_nasa) var _nasa={};
            if(window.wcs){
                wcs.inflow();
                wcs_do();
            }
        if(window.wcs){
            if(!wcs_add) var wcs_add = {};
            window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
            var _conv = {};
                _conv.type = 'lead';
            wcs.trans(_conv);
        }

        // 앱의 스키마 URL
        var appSchemeURL = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
        // 안드로이드와 iOS 마켓 URL
        var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
        var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

        if(this.abx_tid !== undefined) {
            appSchemeURL += `&abx_tid=${this.abx_tid}`;
            // Google Play 스토어 링크
            androidMarketURL += `&referrer=abx_tid%3D${this.abx_tid}`;
            //appstore 스토어 링크
            iosMarketURL += `?&referrer=abx_tid%3D${this.abx_tid}`;
        }

        // 리다이렉트를 체크할 시간 간격
        var timeoutMs = 2000;

        // 앱 실행 시도
        window.location.href = appSchemeURL;

        // 2초 후에 페이지 가시성 체크
        setTimeout(function() {
            if (document.visibilityState === 'visible') {
                // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
                if (navigator.userAgent.match(/Android/i)) {
                    window.location.href = androidMarketURL;
                } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                    window.location.href = iosMarketURL;
                }
                else
                {
                    window.location.href = 'https://event.soldoc.co.kr/';
                }
            }
        }, timeoutMs);
      },
      handleScroll() {
        const secondImage = this.$refs.secondImage;
        const rect = secondImage.getBoundingClientRect();
        this.isScrolled = rect.top <= window.innerHeight - 1600;
      },
    },
    mounted() {
      this.isInApp = this.$route.query.inapp;
      if(this.isInApp === null || this.isInApp === undefined || this.isInApp !== 'true')
      {
        this.isInApp = false;
      }
      else
      {
        this.isInApp = true;
      }

      function getAbxTidParameter() {
        const params = new URLSearchParams(window.location.search);
        return params.get('abx_tid') || true;
      }
      this.abx_tid = getAbxTidParameter();

      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }

  .contain {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    min-width: 800px;
  }

  .contain > img:nth-child(2),
  .contain > img:nth-child(3) {
    margin-top: -1px;
  }

  /*
  .contain > img:not(:last-child) {
    display:block;
    margin-top:-1px;
  }
  */

  .contain .sr-only {
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    margin: 0 !important;
    font-size: 0;
    line-height: 0;
    overflow: hidden;
  }

  .bottom-float-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 35px;
    width: 712px;
    height: 90px;

    visibility: hidden;
    opacity: 0;
    transition: 0.3s ease;
    z-index: 50;
    border-radius: 0.7rem;
    background-color:#000;
    box-shadow: 0 0.237rem 0.948rem 0 rgba(0, 0, 0, 0.10);
  }

  .bottom-float-cta a {
    display:flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
  }

  .bottom-float-cta.scrolled {
    visibility: visible;
    opacity: 1;
  }

  .full-bottom-float-cta {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left:0;
    transform: translate(0, 0);
    width: 800px;
    min-width: 800px;
    padding:30px 44px;

    visibility: hidden;
    opacity: 0;
    transition: 0.3s ease;
    z-index: 50;
    border-radius: 0.7rem 0.7rem 0 0;
    background-color:#fff;
    box-shadow: 0 0.237rem 0.948rem 0 rgba(0, 0, 0, 0.10);
  }

  .full-bottom-float-cta.scrolled {
    visibility: visible;
    opacity: 1;
  }

  .full-bottom-float-cta a {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding:22px 0;

    font-size: 30px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    background: #000;
    line-height: 32px;
    border-radius: 12px;
  }

  .full-bottom-float-cta a:hover,
  .full-bottom-float-cta a:active,
  .full-bottom-float-cta a:focus,
  .full-bottom-float-cta a:not([href]):not([class]),
  .full-bottom-float-cta a:not([href]):not([class]):hover {
    color: #fff;
    text-decoration: none;
  }

  .custom-timer-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 19px;
    margin-bottom: 22px;
  }

  .custom-timer-container .custom-timer-icon {
    display: flex;
    align-items: center;
  }

  .custom-timer-container .custom-timer-icon span {
    display: flex;
    width: 29px;
    height: 29px;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background-color: #0068ff;

    color: #fff;
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
  }

  .custom-timer-container .custom-timer-icon img {
    width: 29px;
  }

  .custom-timer-container .custom-timer-title {
    color: #000;
    font-family: Pretendard, "Pretendard", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
    line-height: 32px; /* 100% */
    letter-spacing: -0.8px;
  }

  .custom-timer-container .custom-timer-title .point {
    color: #0068FF;
  }

  .custom-timer-container .custom-countdown {
    display: flex;
  }

  .custom-timer-container .custom-countdown .custom-time-block {
    display: flex;
  }

  .custom-time-block .time-digits {
    display: flex;
  }

  .custom-time-block .time-digits .digit,
  .custom-time-block .time-digits .separator {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Pretendard, "Pretendard", sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px; /* 100% */
    letter-spacing: -0.68px;
  }

  .custom-time-block .time-digits .digit {
    width: 30px;
    height: 44px;
    padding: 0 4px;
    border-radius: 6px;
    background: #F3F4F4;
    color: #0068FF;
  }

  .custom-time-block .time-digits span:nth-child(3n+1) {
    margin-right:4px;
  }

  .custom-time-block .time-digits .separator {
    color: #333;
  }

  .video-wrap {
    position: relative;
    width: 100%;
    height: 0;
    /* 16:9 비율 */
    padding-bottom: 56.25%;
    overflow: hidden;
  }
  .video-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 800px) {
    .full-bottom-float-cta {
      left:50%;
      transform: translate(-50%, 0);
    }

    .video-wrap {
      width: 800px;
      height: 450px;
      padding-bottom:0;
    }
  }

  /* custom-modal */
  .main-space .info-title {
    color: #0068FF;
  }

  .main-space .box .box-section .section-title {
    color: #0068FF;
  }

  .main-space .box.blue {
    background-color: #F5F9FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c37.vue